import classnames from 'classnames';
import { useSelector } from 'react-redux';
import { useIntl, FormattedMessage, defineMessages } from 'react-intl';

import { Pill } from 'ui-components/components/pill';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import { emptyArray } from 'ui-components/default-props/empty';

import { deliveredDutyPaid } from '../../services/other-shipping-options/constants';
import { OtherShippingOptionsService } from '../../services/other-shipping-options/other-shipping-options-service';
import { useShouldShowDdp } from './use-should-show-ddp';
import Global from '../../store/global-selectors';
import { filterDutiesOptions } from '../../fulfillment-planner/duties-and-taxes/helpers';

import style from './other-shipping-options.module.less';

const messages = defineMessages({
  more: {
    description: 'orderDrawer.otherShippingOptions.more',
    defaultMessage: 'Options',
    id: 'kUGNSq',
  },
});

/**
 * @param {object} props
 * @param {string[]} props.activeOptions
 * @param {string} [props.fulfillmentPlanId]
 * @param {string} [props.className]
 * @param {string} [props.pillClassName]
 * @returns {JSX.Element|null}
 */
const OtherShippingOptionsHeaderPills = ({ activeOptions: originalActiveOptions, fulfillmentPlanId = null, className, pillClassName }) => {
  const intl = useIntl();
  const shouldShowDdp = useShouldShowDdp(fulfillmentPlanId);
  const availableShippingOptions =
    useSelector((state) =>
      Global.selectEntitiesFulfillmentPlanProperty(state, {
        fulfillmentPlanId,
        property: 'availableShippingOptions',
      }),
    ) || emptyArray;

  const hasAvailableDutiesOptions = !!filterDutiesOptions(availableShippingOptions).length;

  if (!originalActiveOptions) {
    return null;
  }
  const activeOptions = originalActiveOptions.filter((option) => {
    if (option === deliveredDutyPaid) {
      return !hasAvailableDutiesOptions && shouldShowDdp;
    }
    return true;
  });

  if (!activeOptions.length) {
    return null;
  }

  const containerClassName = classnames(style['header-info'], className);

  if (activeOptions.length === 1) {
    const [firstKey] = activeOptions;
    return (
      <div className={containerClassName}>
        <Pill
          className={classnames(style['single-pill'], pillClassName)}
          label={<FormattedMessage {...OtherShippingOptionsService.getAbbreviatedName(firstKey)} />}
        />
      </div>
    );
  }

  return (
    <div className={containerClassName}>
      {activeOptions.length > 0 && (
        <Tooltip position='bottom'>
          <TooltipContent>
            <div className={style['tooltip-content']}>
              {activeOptions.map((option) => (
                <div key={option}>
                  <FormattedMessage {...OtherShippingOptionsService.getAbbreviatedName(option)} />
                </div>
              ))}
            </div>
          </TooltipContent>
          <div className={classnames(style.more, pillClassName)}>
            <span className={style['pill-text']}>{`${activeOptions.length} ${intl.formatMessage(messages.more)}`}</span>
          </div>
        </Tooltip>
      )}
    </div>
  );
};

export default OtherShippingOptionsHeaderPills;
